'use client';
import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { AskForPriceDialog } from '@eliadmin/core/src/components/product/dialog/ask-for-price-dialog';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useState } from 'react';

type AskForPriceButtonProps = {
  product: Product | ProductDetailData;
};

export const AskForPriceButton = ({ product }: AskForPriceButtonProps) => {
  const { t } = useTranslations();
  const [isOpenAskForPriceDialog, setIsOpenAskForPriceDialog] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsOpenAskForPriceDialog(true)}
        className="w-full uppercase sm:w-fit"
      >
        {t('text2278')}
      </Button>
      <AskForPriceDialog
        product={product}
        isOpen={isOpenAskForPriceDialog}
        setIsOpen={setIsOpenAskForPriceDialog}
      />
    </>
  );
};
